import React from "react";

const OrganisationSchema = () => (
  <React.Fragment>
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(
         {
  "@context": "https://schema.org",
  "@type": "AmusementPark",
  "name": "Adventure Resort Kufri",
  "description": "Adventure Resort Kufri offers thrilling outdoor adventure activities like zipline, sky swing, go-karting, and family-friendly experiences amidst the scenic hills of Kufri near Shimla.",
  "image": "https://www.adventureresortkufri.com/images/gallery/zipline.jpg",
  "url": "https://www.adventureresortkufri.com/",
  "telephone": "+91 93171 92601",
  "email": "kufrifuncampus@gmail.com",
  "openingHours": "Mo-Su 09:00-18:00",
  "sameAs": [
    "https://www.facebook.com/adventureresortsnew/",
    "https://www.instagram.com/adventureresorts/"
  ],
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "NH-05 New Kufri Gallu Hills",
    "addressLocality": "Shimla",
    "addressRegion": "Himachal Pradesh",
    "postalCode": "171209",
    "addressCountry": {
      "@type": "Country",
      "name": "IN"
    }
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "31.08994442520017",
    "longitude": "77.28644893937323"
  },
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": "https://www.adventureresortkufri.com/"
  },
  "potentialAction": {
    "@type": "ReserveAction",
    "target": {
      "@type": "EntryPoint",
      "name": "Buy Tickets",
      "urlTemplate": "https://www.adventureresortkufri.com/tickets",
      "inLanguage": "en",
      "actionPlatform": [
        "http://schema.org/DesktopWebPlatform",
        "http://schema.org/MobileWebPlatform"
      ]
    },
    "result": {
      "@type": "Reservation",
      "name": "Buy Tickets"
    }
  },
  "subOrganization": [
    {
      "@type": "Organization",
      "name": "About Adventure Resort Kufri",
      "url": "https://www.adventureresortkufri.com/about-us",
      "description": "Learn more about Adventure Resort Kufri and its thrilling experiences."
    },
    {
      "@type": "Organization",
      "name": "Adventure Activities",
      "url": "https://www.adventureresortkufri.com/activities",
      "description": "Explore zipline, sky swing, go-karting, and other adventure activities in Kufri."
    },
    {
      "@type": "Organization",
      "name": "Adventure Resort Kufri Blog",
      "url": "https://www.adventureresortkufri.com/blogs",
      "description": "Read latest blogs about adventure activities and travel in Kufri and Shimla."
    },
    {
      "@type": "Organization",
      "name": "Contact Adventure Resort Kufri",
      "url": "https://www.adventureresortkufri.com/contact-us",
      "description": "Get in touch for bookings and inquiries."
    },
    {
      "@type": "Organization",
      "name": "Book Tickets - Adventure Resort Kufri",
      "url": "https://www.adventureresortkufri.com/tickets",
      "description": "Book your adventure tickets online for a hassle-free experience."
    }
  ],
  "contactPoint": {
    "@type": "ContactPoint",
    "telephone": "+91 93171 92601",
    "email": "kufrifuncampus@gmail.com",
    "contactType": "Customer Service",
    "areaServed": "IN",
    "availableLanguage": "en"
  }
}
        )
      }}
    />
  </React.Fragment>
);
export default OrganisationSchema;